import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import { HashRouter as Router } from 'react-router-dom';
import { AppLayout } from '@app/AppLayout/AppLayout';
import { AppRoutes } from '@app/routes';
import { ThemeProvider } from '@app/utils/theme';
import '@app/app.css';
import '@app/ACMOpenShift/acmShell.css';
import '@app/ACMOpenShift/acmPageLayout.css';
import '@app/dark-theme.css';

const App: React.FunctionComponent = () => (
  <ThemeProvider>
    <Router>
      <AppLayout>
        <AppRoutes />
      </AppLayout>
    </Router>
  </ThemeProvider>
);

export default App;
